/** Label for company website links: actual URL when set, otherwise the fallback "Website". */
export function getCompanyWebsiteDisplayLabel(website?: string | null): string {
  const trimmed = (website ?? "").trim();
  return trimmed || "Website";
}

export function hasCompanyWebsite(website?: string | null): boolean {
  return (website ?? "").trim().length > 0;
}
